import styled, { css } from 'styled-components';

import { colorScheme } from '../../theme';

interface textProps {
  variant?: string;
}

const basicStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  marginBottom: '8px',
};

const variantStyles = (variant = 'primary') =>
  ({
    primary: css`
      ${basicStyle}
      color: ${colorScheme.text.base};
    `,
    secondary: css`
      ${basicStyle}
      font-weight: 500;
      color: ${colorScheme.text.base};
      opacity: 0.8;
    `,
    ternary: css`
      ${basicStyle}
      color: ${colorScheme.text.base};
      opacity: 0.6;
    `,
  })[variant];

export const Text = styled.p<textProps>`
  ${({ variant }) => variantStyles(variant)}
`;
